module.exports = __webpack_public_path__ + "static/media/2.00c26490.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/2.svg
// module id = 230
// module chunks = 1